import React from "react";
import Webcam from "react-webcam";
// Gesture logic moved to GestureControl component
import Modal from "../../components/Modal";
import ScriptScroller from "./karaoke/ScriptScroller";
import { stripHtml } from "../../../utils";
import WpmControl from "./karaoke/WpmControl";
import TextSizeControl from "./karaoke/TextSizeControl";
import CameraSelect from "./karaoke/CameraSelect";
import MicSelect from "./karaoke/MicSelect";
import ZoomControl from "./karaoke/ZoomControl";
import CloseButton from "./karaoke/CloseButton";
import StartCameraButton from "./karaoke/StartCameraButton";
import StartRecordingButton from "./karaoke/StartRecordingButton";
import StopRecordingButton from "./karaoke/StopRecordingButton";
import UploadButton from "./upload/UploadButton";
import DownloadButton from "./karaoke/DownloadButton";
import { Action } from "./karaoke/actions";
import RecordingIndicator from "./karaoke/RecordingIndicator";
import VideoPlaybackControl from "./VideoPlaybackControl";
import VideoSelector from "./VideoSelector";
import { listChapterVideos } from "../../../services/videos";

import GestureControl from "./gesture/GestureControl";

export default class LiveReadKaraoke extends React.Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.gestureRef = React.createRef();
    this._recordedChunks = [];

    const savedWpm = Number(localStorage.getItem('lrp-wpm'));
    const savedCamZoom = Number(localStorage.getItem('lrp-cam-zoom'));
    const savedFont = Number(localStorage.getItem('lrp-font-size'));
    const savedVideoId = (localStorage.getItem('lrp-video-device-id') || '').trim();
    const savedAudioId = (localStorage.getItem('lrp-audio-device-id') || '').trim();
    this.state = {
      firedGesture: null,
      isRecording: false,
      isPaused: false,
      hasRecordedVideo: false,
      chapterVideoUrl: "",
      chapterVideoId: null,
      chapterVideos: [],
      isPlayingBack: false,
      userForcedCamera: false,
      uploading: false,
      uploadPct: 0,
      scrollerWpm: Number.isFinite(savedWpm) && savedWpm > 0 ? savedWpm : 190,
      camZoom: Number.isFinite(savedCamZoom) && savedCamZoom >= 1 ? savedCamZoom : 1,
      fontSizePx: Number.isFinite(savedFont) && savedFont >= 20 && savedFont <= 100 ? savedFont : 50,
      selectedVideoDeviceId: savedVideoId,
      selectedAudioDeviceId: savedAudioId,
      mediaError: null,
    };
  }

  componentDidMount() {
    const initialUrl = this.props?.video?.url || this.props?.video?.presigned_url || "";
    if (initialUrl) this.setState({ chapterVideoUrl: initialUrl, isPlayingBack: true });
    this.refreshChapterVideos();
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.chapter?.id || null) !== (this.props.chapter?.id || null)) {
      this.setState({ isPlayingBack: false, chapterVideos: [], chapterVideoUrl: "" });
      this.refreshChapterVideos();
    }
    const prevUrl = prevProps?.video?.url || prevProps?.video?.presigned_url || "";
    const nextUrl = this.props?.video?.url || this.props?.video?.presigned_url || "";
    if (nextUrl && nextUrl !== prevUrl && nextUrl !== this.state.chapterVideoUrl) {
      this.setState({ chapterVideoUrl: nextUrl, isPlayingBack: true });
    }
  }

 

  // Gesture recognition & recording handled externally

  async refreshChapterVideos() {
    try {
      const chapterId = this.props?.chapter?.id;
      if (!chapterId) return;
      const items = await listChapterVideos(chapterId);
      if (Array.isArray(items) && items.length) {
        const newest = items[0];
        const newestUrl = newest?.url || "";
        const newestId = newest?.id || null;
        this.setState((prev) => ({
          chapterVideos: items,
          chapterVideoUrl: prev.chapterVideoUrl || newestUrl,
          chapterVideoId: prev.chapterVideoId || newestId,
          // Respect user override: only auto-switch to playback if user hasn't forced camera
          isPlayingBack: prev.userForcedCamera ? prev.isPlayingBack : !!(prev.chapterVideoUrl || newestUrl),
        }));
      } else {
        this.setState({ chapterVideos: [] });
      }
    } catch (_) {}
  }

  getVideoEl() {
    const v = this.webcamRef?.current?.video;
    return v && v.readyState >= 2 ? v : null;
  }

  applyTrackZoom = () => {
    try {
      const stream = this.webcamRef?.current?.stream || this.getVideoEl()?.srcObject;
      const track = stream ? stream.getVideoTracks?.()[0] : null;
      if (!track || typeof track.getCapabilities !== 'function') return;
      const caps = track.getCapabilities();
  if (!caps || typeof caps.zoom === 'undefined') return;
      const settings = track.getSettings ? track.getSettings() : {};
      const min = (caps.zoom && caps.zoom.min) || 1;
      const max = (caps.zoom && caps.zoom.max) || 1;
      if (max <= min) return;
  const desiredMaxScale = 3;
      const frac = Math.max(0, Math.min(1, (this.state.camZoom - 1) / (desiredMaxScale - 1)));
      const target = min + frac * (max - min);
      track.applyConstraints({ advanced: [{ zoom: target }] }).catch(() => {});
    } catch (_) {}
  }

  setCamZoom = (val) => {
    const clamped = Math.max(1, Math.min(3, Number(val) || 1));
    this.setState({ camZoom: clamped }, () => {
      try { localStorage.setItem('lrp-cam-zoom', String(clamped)); } catch (_) {}
      this.applyTrackZoom();
    });
  }

  zoomIn = () => this.setCamZoom((this.state.camZoom + 0.1).toFixed(2));
  zoomOut = () => this.setCamZoom((this.state.camZoom - 0.1).toFixed(2));

  isPalmHorizontalDown(landmarks) {
    try {
      const w = landmarks[0];
      const i = landmarks[5];
      const p = landmarks[17];
      const v1 = { x: i.x - w.x, y: i.y - w.y, z: i.z - w.z };
      const v2 = { x: p.x - w.x, y: p.y - w.y, z: p.z - w.z };
      const n = {
        x: v1.y * v2.z - v1.z * v2.y,
        y: v1.z * v2.x - v1.x * v2.z,
        z: v1.x * v2.y - v1.y * v2.x,
      };
      const forwardish = n.z > 0;
      const flatish = Math.abs(n.y) < 0.25;
      return forwardish && flatish;
    } catch (_) {
      return false;
    }
  }

  // Recording lifecycle handled by GestureControl

  handleUploadStart = () => {
    this.setState({ uploading: true, uploadPct: 0 });
  };

  handleUploadComplete = (data) => {
    if (typeof this.props.onUploadComplete === 'function') {
      try { this.props.onUploadComplete(data); } catch (_) {}
    }
    const returnedUrl = data?.url || data?.presigned_url || data?.playbackUrl || "";
    this.setState({ 
      uploading: false, 
      uploadPct: 100, 
      hasRecordedVideo: false, 
      chapterVideoUrl: returnedUrl || this.state.chapterVideoUrl, 
      isPlayingBack: true 
    }, () => {
      this.refreshChapterVideos();
    });
    this._recordedBlob = null;
    this._recordedChunks = [];
  };

  handleUploadProgress = (pct) => {
    this.setState({ uploadPct: pct });
  };

  handleUploadError = () => {
    this.setState({ uploading: false });
  };

  startPlayback = () => {
    if (!this.state.chapterVideoUrl) return;
    this.setState({ isPlayingBack: true, userForcedCamera: false });
  };

  stopPlayback = () => {
    this.setState({ isPlayingBack: false, userForcedCamera: false });
  };

  // Removed inline gesture methods

  renderDesktopControls() {
    const { onClose } = this.props;
    return (
      <>
        {this.state.mediaError ? (
          <div style={{ color: '#ffb3b3', fontSize: 12 }}>
            {this.state.mediaError}
          </div>
        ) : null}

        {!this.state.isPlayingBack && 
          <WpmControl
              value={this.state.scrollerWpm}
              onChange={(wpm) => {
                this.setState({ scrollerWpm: wpm });
                try { localStorage.setItem('lrp-wpm', String(wpm)); } catch (_) {}
              }}
            />            
        }
        {!this.state.isPlayingBack &&
          <TextSizeControl
              value={this.state.fontSizePx}
              onChange={(px) => {
                this.setState({ fontSizePx: px });
                try { localStorage.setItem('lrp-font-size', String(px)); } catch (_) {}
              }}
            />
        }
 {!this.state.isPlayingBack && 
        <CameraSelect
          value={this.state.selectedVideoDeviceId}
          onChange={(id) => {
            this.setState({ selectedVideoDeviceId: id }, () => {
              try { localStorage.setItem('lrp-video-device-id', id); } catch (_) {}
            });
          }}
        />
  }
 {!this.state.isPlayingBack && 
        <ZoomControl
          value={this.state.camZoom}
          onChange={(val) => this.setCamZoom(val)}
          onZoomIn={this.zoomIn}
          onZoomOut={this.zoomOut}
        />
 }
 {!this.state.isPlayingBack && 
        <MicSelect
          value={this.state.selectedAudioDeviceId}
          onChange={(id) => {
            this.setState({ selectedAudioDeviceId: id }, () => {
              try { localStorage.setItem('lrp-audio-device-id', id); } catch (_) {}
            });
          }}
        />
  }

        <CloseButton onClick={onClose} />
        {(this.state.hasRecordedVideo && !this.state.uploading) || this.state.chapterVideoUrl ? (
          <DownloadButton
            recordedBlob={this._recordedBlob}
            videoUrl={this.state.chapterVideoUrl}
            videoId={this.state.chapterVideoId}
            chapterTitle={this.props?.chapter?.title}
          />
        ) : null}
        
        {!this.state.isRecording && !this.state.uploading && !this.state.hasRecordedVideo && this.state.isPlayingBack && (
          <StartCameraButton onClick={() => this.setState({ isPlayingBack: false, userForcedCamera: true })} />
        )}
        
        {!this.state.isRecording && !this.state.uploading && !this.state.hasRecordedVideo && !this.state.isPlayingBack && (
          <StartRecordingButton onClick={() => this.gestureRef.current?.handleAction(Action.START)} />
        )}
        
        {this.state.isRecording && (
          <StopRecordingButton onClick={() => this.gestureRef.current?.handleAction(Action.STOP)} />
        )}
        
        {this.state.hasRecordedVideo && !this.state.isRecording && (
          <UploadButton 
            uploading={this.state.uploading} 
            uploadPct={this.state.uploadPct}
            recordedBlob={this._recordedBlob}
            chapterTitle={this.props?.chapter?.title}
            chapterId={this.props?.chapter?.id}
            projectId={this.props?.projectId}
            onUploadStart={this.handleUploadStart}
            onUploadComplete={this.handleUploadComplete}
            onUploadProgress={this.handleUploadProgress}
            onUploadError={this.handleUploadError}
          />
        )}
      </>
    );
  }

  renderMobileControls() {
    const { onClose } = this.props;
    return (
      <>
        {this.state.mediaError ? (
          <div style={{ color: '#ffb3b3', fontSize: 12, width: '100%' }}>
            {this.state.mediaError}
          </div>
        ) : null}

        {!this.state.isRecording && !this.state.uploading && !this.state.hasRecordedVideo && this.state.isPlayingBack && (
          <StartCameraButton onClick={() => this.setState({ isPlayingBack: false, userForcedCamera: true })} />
        )}
        
        {!this.state.isRecording && !this.state.uploading && !this.state.hasRecordedVideo && !this.state.isPlayingBack && (
          <StartRecordingButton onClick={() => this.gestureRef.current?.handleAction(Action.START)} />
        )}
        
        {this.state.isRecording && (
          <StopRecordingButton onClick={() => this.gestureRef.current?.handleAction(Action.STOP)} />
        )}
        
        {this.state.hasRecordedVideo && !this.state.isRecording && (
          <UploadButton 
            uploading={this.state.uploading} 
            uploadPct={this.state.uploadPct}
            recordedBlob={this._recordedBlob}
            chapterTitle={this.props?.chapter?.title}
            chapterId={this.props?.chapter?.id}
            projectId={this.props?.projectId}
            onUploadStart={this.handleUploadStart}
            onUploadComplete={this.handleUploadComplete}
            onUploadProgress={this.handleUploadProgress}
            onUploadError={this.handleUploadError}
          />
        )}

        {(this.state.hasRecordedVideo && !this.state.uploading) || this.state.chapterVideoUrl ? (
          <DownloadButton
            recordedBlob={this._recordedBlob}
            videoUrl={this.state.chapterVideoUrl}
            videoId={this.state.chapterVideoId}
            chapterTitle={this.props?.chapter?.title}
          />
        ) : null}

        <CloseButton onClick={onClose} />

        {!this.state.isPlayingBack && 
                <CameraSelect
                  value={this.state.selectedVideoDeviceId}
                  onChange={(id) => {
                    this.setState({ selectedVideoDeviceId: id }, () => {
                      try { localStorage.setItem('lrp-video-device-id', id); } catch (_) {}
                    });
                  }}
                />
          }

    {!this.state.isPlayingBack && 
            <ZoomControl
              value={this.state.camZoom}
              onChange={(val) => this.setCamZoom(val)}
              onZoomIn={this.zoomIn}
              onZoomOut={this.zoomOut}
            />
    }
    {!this.state.isPlayingBack && 
        <MicSelect
          value={this.state.selectedAudioDeviceId}
          onChange={(id) => {
            this.setState({ selectedAudioDeviceId: id }, () => {
              try { localStorage.setItem('lrp-audio-device-id', id); } catch (_) {}
            });
          }}
        />
        }

        {!this.state.isPlayingBack && 
          <WpmControl
              value={this.state.scrollerWpm}
              onChange={(wpm) => {
                this.setState({ scrollerWpm: wpm });
                try { localStorage.setItem('lrp-wpm', String(wpm)); } catch (_) {}
              }}
            />            
        }
        {!this.state.isPlayingBack &&
          <TextSizeControl
              value={this.state.fontSizePx}
              onChange={(px) => {
                this.setState({ fontSizePx: px });
                try { localStorage.setItem('lrp-font-size', String(px)); } catch (_) {}
              }}
            />
        }
      </>
    );
  }

  render() {
    const {
      isOpen,
      onClose,      
      chapter,
      overlayLines,
      readingTime,
    } = this.props;

  const title = chapter?.title || 'Preview';
  const hasDefaultVideo = !!this.state.chapterVideoUrl;

    return (
      <Modal isOpen={isOpen} onClose={onClose} fullscreen>
        <div className="lrp-modal">
          <div className="lrp-control-row" style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
            <h3 className="lrp-modal-title" style={{ marginRight: 12 }}>
              Live Read — {title}
              {readingTime ? (
                <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.8 }}>{readingTime}</span>
              ) : null}
            </h3>
            
          </div>
            
            {chapter?.content && (!hasDefaultVideo || !this.state.isPlayingBack) ? (
              <div className="lrp-scroller-wrap">
                <ScriptScroller
                  text={stripHtml(chapter.content)}
                  wpm={this.state.scrollerWpm}
                  style={{ fontSize: `${this.state.fontSizePx}px` }}
                  gestureAction={this.state.firedGesture}
                />
              </div>
            ) : null}
          <div className="lrp-preview">
            <RecordingIndicator
              isRecording={this.state.isRecording}
              isPaused={this.state.isPaused}
              hasRecordedVideo={this.state.hasRecordedVideo}
              uploading={this.state.uploading}
              uploadPct={this.state.uploadPct}
            />
            <VideoPlaybackControl
              videoUrl={this.state.chapterVideoUrl}
              isPlayingBack={this.state.isPlayingBack}
              canShowOverlay={!this.state.isRecording && !this.state.uploading && this.state.chapterVideoUrl && this.state.isPlayingBack}
              onStartPlayback={this.startPlayback}
              onStopPlayback={this.stopPlayback}
            />            
            {!this.state.userForcedCamera && (
              <VideoSelector
                videos={this.state.chapterVideos}
                currentVideoUrl={this.state.chapterVideoUrl}
                onSelectVideo={(url) => this.setState({ chapterVideoUrl: url, isPlayingBack: true, userForcedCamera: false })}
              />
            )}                        

            {!this.state.isPlayingBack ? (
              <Webcam
                audio={true}
                mirrored
                className="lrp-webcam"
                style={{ transform: `scale(${this.state.camZoom})`, transformOrigin: 'center center', transition: 'transform .2s ease' }}
                videoConstraints={ this.state.selectedVideoDeviceId ? { deviceId: { exact: this.state.selectedVideoDeviceId } } : { facingMode: 'user' } }
                audioConstraints={ this.state.selectedAudioDeviceId 
                  ? { deviceId: { exact: this.state.selectedAudioDeviceId }, echoCancellation: true, noiseSuppression: true, autoGainControl: false }
                  : { echoCancellation: true, noiseSuppression: true, autoGainControl: false } }
                muted
                playsInline
                onUserMedia={() => { this.applyTrackZoom(); }}
                onUserMediaError={(err) => {
                  try { console.warn('Webcam media error', err); } catch (_) {}
                  this.setState({ mediaError: 'Unable to access camera/microphone. Please check permissions and device selection.' });
                  try {
                    localStorage.removeItem('lrp-video-device-id');
                    localStorage.removeItem('lrp-audio-device-id');
                  } catch (_) {}
                  this.setState({ selectedVideoDeviceId: '', selectedAudioDeviceId: '' });
                }}
                key={`cam-${this.state.selectedVideoDeviceId || 'default'}-${this.state.selectedAudioDeviceId || 'default'}`}
                ref={this.webcamRef}
              />
            ) : null}

            <GestureControl
              ref={this.gestureRef}
              hideControls={this.state.isPlayingBack}
              active={!this.state.isPlayingBack}
              videoRef={this.webcamRef}
              isRecording={this.state.isRecording}
              isPaused={this.state.isPaused}
              onStateChange={(patch) => this.setState(patch)}
              onGesture={(action, meta) => {
                this.setState({ firedGesture: action });
                if (typeof this.props.onGesture === 'function') {
                  try { this.props.onGesture(action, meta); } catch (_) {}
                }
              }}
              onStartRecording={this.props.onStartRecording}
              onRecorded={(blob) => { this._recordedBlob = blob; this.setState({ hasRecordedVideo: true }); }}
            />
          </div>

          <div className="lrp-modal-actions">
            <div className="lrp-desktop-controls">
              {this.renderDesktopControls()}
            </div>
            <div className="lrp-mobile-controls">
              {this.renderMobileControls()}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
